import dispatchEvent from '../utils/dispatch-event.js';
import EVENT from '../enums/event.js';
import STATE from '../enums/state.js';

class SubscriptionOption extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('button');
    this.registerEvents();
  }

  /**
   *
   * @param {'true'|'false'} state
   */
  setState(state) {
    this.dataset.selected = state;
    this.input.dataset.selected = state;
  }

  registerEvents() {
    this.input.addEventListener('click', () => {
      dispatchEvent(EVENT.SUBSCRIPTION.OPTION.SELECTED, document, {
        detail: {
          option: this.input.dataset.value,
        },
      });

      this.setState(STATE.SUBSCRIPTION.OPTION.SELECTED.TRUE);
    });

    document.addEventListener(EVENT.SUBSCRIPTION.OPTION.SELECTED, e => {
      if (e.target.detail === this.dataset.option) {
        this.setState(STATE.SUBSCRIPTION.OPTION.SELECTED.TRUE);
      } else {
        this.setState(STATE.SUBSCRIPTION.OPTION.SELECTED.FALSE);
      }
    });
  }
}

customElements.define('subscription-option', SubscriptionOption);
